// Tailwind `lg` — same cutoff as the theater toggle's `max-lg:hidden`.
export const THEATER_MODE_DESKTOP_MQ = '(min-width: 1024px)'

export function theaterModeAvailable(matchMediaImpl = globalThis.matchMedia) {
  return !!matchMediaImpl?.(THEATER_MODE_DESKTOP_MQ)?.matches
}

// Preference stays saved; we just refuse the layout below the desktop breakpoint.
export function desiredTheaterLayout({ available, preferenceOn }) {
  return !!available && !!preferenceOn
}
